import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { client, consoleLogInDev } from 'shared';
import { Grid } from '@material-ui/core';
import NotFound from '../../../internal/shared/NotFound';
import TopProviders from '../TopProviders';
import { Text } from 'library';
import IndeedHomeBase from './IndeedHomeBase';
import IndeedTopCard from './IndeedTopCard';
import TandemFreeValueProp from './TandemFreeValueProp';
import IndeedCard from './components/IndeedCard';
import ProviderTopJobs from '../provider-home-page/ProviderTopJobs';
import { SignUpDialog } from '../public-application/SignUpDialog';
import { useDeprecatedTrackingCookies } from 'parent-portal/shared/DeprecatedSourceTracking';
import usePublicSessionTracking, { PublicSessionEventType } from '../../shared/PublicSessionTracking';

type ProfileParams = {
    id: string;
};

const IndeedHomePage = () => {
    const [outreachNotFound, setOutreachNotFound] = useState<boolean>(false);
    const [firstName, setFirstName] = useState<string>('');
    const [jobAccessor, setjobAccessor] = useState<string>('');
    const [isDialog, setIsDialog] = useState<boolean>(false);
    const [userCreated, setUserCreated] = useState<boolean>(false);
    const { id } = useParams<ProfileParams>();
    const { trackSession, usePageLoadTracking } = usePublicSessionTracking('Indeed Landing Page');

    usePageLoadTracking();

    useDeprecatedTrackingCookies(`/indeed/${id}`);

    useEffect(() => {
        loadUserData();
    }, []);

    const loadUserData = async () => {
        client(`api/outreach/${id}`)
            .then((res) => {
                let sessionData: any = { pk: id };
                if (!!res?.first_name) {
                    setFirstName(res.first_name);
                    sessionData['first_name'] = res.first_name;
                }
                if (!!res?.job_accessor) {
                    setjobAccessor(res.job_accessor);
                    sessionData['job_accessor'] = res.job_accessor;
                }
                if (!!res?.user_exists) {
                    setUserCreated(res.user_exists);
                    sessionData['user_exists'] = res.user_exists;
                }
                if (!!res?.ciid) {
                    sessionData['ciid'] = res.ciid;
                }
            })
            .catch((e) => {
                consoleLogInDev(e);
                setOutreachNotFound(true);
                trackSession('ERROR', `Outreach not found: ${id}`);
            });
    };

    const handleClickOverride = (title: string) => {
        setIsDialog(true);
        trackSession('DIALOG_OPEN', `${title} - Override to Partial Signup`, PublicSessionEventType.User);
    };

    const handleDialogClose = () => {
        setIsDialog(false);
        trackSession('DIALOG_CLOSE', 'Partial Signup', PublicSessionEventType.User);
    };

    return outreachNotFound ? (
        <NotFound />
    ) : (
        <IndeedHomeBase>
            <Grid container direction="column" alignItems="center" justify="center" spacing={5}>
                <Grid item xs={11} style={{ width: '100%' }}>
                    <Text variant="display">Thanks for applying on Indeed, {firstName}!</Text>
                </Grid>
                <Grid item xs={12} style={{ width: '100%' }}>
                    <IndeedTopCard
                        jobAccessor={jobAccessor}
                        onLoadFail={() => setOutreachNotFound(true)}
                        userCreated={userCreated}
                        onUserCreated={() => setUserCreated(true)}
                    />
                </Grid>
                <Grid item xs={12} style={{ width: '100%' }}>
                    <TandemFreeValueProp />
                </Grid>
                <Grid item>
                    <IndeedCard>
                        <ProviderTopJobs
                            altDisplay={true}
                            otherCopy="Apply to similar jobs and more!"
                            overrideClick={userCreated ? undefined : () => handleClickOverride('Click Job Details')}
                        />
                    </IndeedCard>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <IndeedCard style={{ backgroundColor: 'rgba(243, 255, 208, 0.5)' }}>
                        <TopProviders
                            otherCopy="Other care providers near you are finding jobs every day."
                            centerHeader={true}
                            overrideClick={userCreated ? undefined : () => handleClickOverride('Click Profile Details')}
                        />
                    </IndeedCard>
                </Grid>
                <Grid item>
                    <SignUpDialog
                        isOpen={isDialog}
                        onClose={handleDialogClose}
                        route="Indeed Home"
                        onUserCreated={() => setUserCreated(true)}
                    />
                </Grid>
            </Grid>
        </IndeedHomeBase>
    );
};

export default IndeedHomePage;
